import { Canvas, Group, IText, StaticCanvas } from 'fabric';
import { applyAllAttachTo, applyAllChainRecenter } from '../../layout';
import { isPillTextbox } from '../types';

const WIRED_KEY = '__pillGroupWired';
type MarkedGroup = Group & { [WIRED_KEY]?: boolean };

/**
 * Enables inline editing for pills inside a group.
 * The group must use `subTargetCheck: true`.
 */
export function wireGroupInlineEdit(group: Group, canvas: StaticCanvas): void {
  const marked = group as MarkedGroup;

  // Avoid registering the same events twice.
  if (marked[WIRED_KEY]) return;
  marked[WIRED_KEY] = true;

  group.on('mousedblclick', e => {
    const subs = (e.subTargets ?? []).filter((target): target is IText => target instanceof IText);

    if (subs.length === 0) return;

    // Pick the pill that was actually clicked.
    const hit = e.scenePoint ? subs.find(target => target.containsPoint(e.scenePoint)) : undefined;

    const target = hit ?? subs[0];

    if (canvas instanceof Canvas) {
      canvas.setActiveObject(target);
    }

    target.enterEditing();
  });

  // Update the chain without moving the other pills while typing.
  const liveReflow = () => {
    applyAllAttachTo(canvas);
    canvas.requestRenderAll();
  };

  // Recenter the chain when editing finishes.
  const settleReflow = () => {
    applyAllAttachTo(canvas);
    applyAllChainRecenter(canvas);
    canvas.requestRenderAll();
  };

  for (const child of group.getObjects()) {
    if (child instanceof IText && isPillTextbox(child)) {
      child.on('changed', liveReflow);
      child.on('editing:exited', settleReflow);
    }
  }
}
